<template>
  <el-card shadow="always" :body-style="{ padding: '20px', height: '72vh' }">
    <div slot="header" class="FC">
      <img src="@/assets/home/videoIoc.png" alt="" />
      <span style="margin-left: 16px; font-weight: bold; font-size: 15px"
        >项目概况</span
      >
    </div>
    <!-- card body -->
    <div>
      <div class="flex" style="justify-content: start; flex-wrap: wrap">
        <!-- <video
          v-for="i in 10"
          style="border-radius: 16px;width:305px;height:180px;object-fit: fill;padding: 5px;"
          src="../../../../assets/img/Wisdom/车辆管理-闸机.mp4"
          controls
        ></video> -->
        <div
          v-for="item in VideotableData"
          :key="item.pjvd01"
          class="divtop inblock"
        >
          <template v-if="item.pjvd03 == 1">
            <video
              style="width: 100%; height: 200px; border-radius: 6px"
              :src="$store.state.baseUrl + item.pjvd04"
              controls="controls"
              wmode="Opaque"
            ></video>
            <div class="delete-img">
              <el-button
                type="danger"
                class="dangBut"
                @click="delVid(item.pjvd01)"
                >删除</el-button
              >
            </div>
          </template>
          <template v-if="item.pjvd03 == 2">
            <el-image
              style="width: 100%; height: 200px; border-radius: 6px"
              :src="$store.state.baseUrl + item.pjvd04"
            >
            </el-image>
            <div class="delete-img">
              <el-button
                type="danger"
                class="dangBut"
                @click="delVid(item.pjvd01)"
                >删除</el-button
              >
            </div>
          </template>
        </div>
        <div class="uploadMain inblock" @click="openUpload">
          <p>点击上传</p>
          <span>为保证最佳效果,请上传16:9比例的文件</span>
        </div>
      </div>
    </div>
    <!-- 添加视频 -->
    <el-dialog title="添加" :visible.sync="InserpictureVisible" width="30%">
      <el-form ref="uploadForm" :model="FileFrom" label-width="100px">
        <el-form-item label="上传类型">
          <el-radio-group v-model="FileFrom.pictureType">
            <el-radio label="1">视频</el-radio>
            <el-radio label="2">图片</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-show="FileFrom.pictureType == 1">
          <el-form-item label="展示文件" class="formUpload">
            <el-upload
              class="upload-demo"
              action="#"
              drag
              multiple
              :on-change="handleChangeVideo"
              :auto-upload="false"
              :file-list="FileFrom.fileListVideo"
              accept=".mp4,.mkv,.MP4,.MKV"
            >
              <div class="el-upload__text" style="margin-top: 15%">
                <em>点击上传</em>&nbsp;&nbsp; / &nbsp;&nbsp;拖拽到此区域
              </div>
              <div
                style="margin-top: 5%; color: #cfd2d8"
                class="el-upload__tip"
              >
                支持MP4、MKV格式
              </div>
            </el-upload>
          </el-form-item>
        </div>
        <div v-show="FileFrom.pictureType == 2">
          <el-form-item label="展示文件" class="formUpload">
            <el-upload
              class="upload-demo"
              action="#"
              drag
              multiple
              :on-change="handleChange"
              :auto-upload="false"
              :file-list="FileFrom.fileListImg"
              accept=".jpg,.jpeg,.png,.JPG,.JPEG"
            >
              <div class="el-upload__text" style="margin-top: 15%">
                <em>点击上传</em>&nbsp;&nbsp; / &nbsp;&nbsp;拖拽到此区域
              </div>
              <div
                style="margin-top: 5%; color: #cfd2d8"
                class="el-upload__tip"
              >
                为保证最佳显示效果，请上传16:9比例的文件
              </div>
            </el-upload>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="InserpictureVisible = false">取 消</el-button>
        <el-button type="primary" @click="Insertpicturedeter('uploadForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { GetPjvideos, Uploadvideo, Deletepjvideo } from "@/setAxios";
export default {
  name: "RunhongXUGK",
  data() {
    return {
      VideotableData: [], //视频展示列表
      InserpictureVisible: false,
      FileFrom: {
        pictureType: "1",
        fileListVideo: [],
        fileListImg: [],
      },
    };
  },

  mounted() {},
  created() {
    this.getProViodeList();
  },
  methods: {
    //打开上传视频弹窗
    openUpload() {
      this.InserpictureVisible = true;
    },
    //获取视频、图片数据
    getProViodeList() {
      let params = {
        xid: this.$store.state.xid,
      };
      GetPjvideos({ params }).then((res) => {
        this.VideotableData = res.Data.list;
      });
    },
    //上传确定按钮
    Insertpicturedeter(uploadForm) {
      this.$refs[uploadForm].validate((v) => {
        if (v) {
          this.UploadFileFrom = new FormData();
          this.UploadFileFrom.append("xid", this.$store.state.xid);
          this.UploadFileFrom.append(
            "type",
            parseInt(this.FileFrom.pictureType)
          );
          switch (parseInt(this.FileFrom.pictureType)) {
            case 1:
              this.FileFrom.fileListVideo.forEach((file) => {
                this.UploadFileFrom.append("file", file.raw);
              });
              break;
            case 2:
              this.FileFrom.fileListImg.forEach((file) => {
                this.UploadFileFrom.append("file", file.raw);
              });
              break;
            default:
              break;
          }
          Uploadvideo(this.UploadFileFrom).then((res) => {
            if (res.Code) {
              this.$message({
                type: "success",
                message: "上传成功!",
              });
              this.InserpictureVisible = false;
              this.getProViodeList();
              this.FileFrom = {
                pictureType: "1",
                fileListVideo: [],
                fileListImg: [],
              };
            } else {
              this.$message.error(res.Message);
            }
          });
        }
      });
    },
    //删除图片、视频
    delVid(id) {
      this.$confirm("确定删除该项?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let params = {
            id: id,
          };
          let res = await Deletepjvideo(params);
          if (res.Code) {
            this.$message({
              type: "success",
              message: "移除成功!",
            });
            this.getProViodeList();
            this.FileFrom = {
              pictureType: "1",
              fileListVideo: [],
              fileListImg: [],
            };
          } else {
            this.$message({
              type: "error",
              message: "移除失败!",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //添加上传图片
    handleChange(file, fileList) {
      this.FileFrom.fileListImg = fileList.slice(-3);
    },
    //添加上传视频
    handleChangeVideo(file, fileList) {
      this.FileFrom.fileListVideo = fileList.slice(-3);
    },
  },
};
</script>

<style lang="less" scoped>
.inblock {
  display: inline-block;
}
.divtop {
  width: 18vw;
  height: 200px;
  margin-right: 20px;
  margin-bottom: 20px;
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  .delete-img {
    display: none;
    .dangBut {
      position: relative;
      left: 38%;
      top: 80px;
    }
  }
  &:hover {
    .delete-img {
      display: block;
      width: 18vw;
      height: 200px;
      float: left;
      z-index: 999;
      margin-top: -204px;
      border-radius: 6px;
      background: rgba(59, 60, 61, 0.5);
      cursor: pointer;
    }
  }
}
.divtop:hover {
  cursor: pointer;
}
.uploadMain {
  border: 1px dashed #dcdcdc;
  border-radius: 6px;
  width: 18vw;
  height: 200px;
  margin-right: 20px;
  margin-bottom: 20px;
  text-align: center;
  p {
    font-size: 15px;
    color: #407de2;
    margin-top: 24%;
  }
  span {
    font-size: 14px;
    color: #c3c3c3;
    position: relative;
    top: 35%;
  }
}
.uploadMain:hover {
  cursor: pointer;
  border-color: #407de2;
}
</style>
